import React from 'react';
import { Helmet } from 'react-helmet-async';

// Sets per-page SEO metadata. Keep titles under 60 characters and
// descriptions under 155 characters. The og:* tags mirror the page
// title/description so social shares match what search results show;
// site-wide defaults live in public/index.html.
const Seo = ({ title, description }) => (
  <Helmet>
    <title>{title}</title>
    <meta name="description" content={description} />
    <meta property="og:title" content={title} />
    <meta property="og:description" content={description} />
  </Helmet>
);

export default Seo;
